import { NumberFormat } from "../../utils/tools"

class ButtonSelect {
  constructor(button={}){
    this.caption = button.caption ? button.caption : "Opção"
    this.value =  button.value ? NumberFormat(button.value) : "0,00"

    this.clone= function(){
      return new ButtonSelect({...this})
    }

    this.copyFrom = function(button = new ButtonSelect){
      this.caption = button.caption
      this.value = button.value
    }
  }
}

export default ButtonSelect